import React from "react";
import { Link } from "react-router-dom";
import "./cta.scss";

function Cta(props) {
  const CustomTag = props.tagName || Link;
  const ctaClass = `cta ${props.ctaClass}${
    props.iconClass ? " cta--with-icon" : ""
  }`;

  return (
    <CustomTag
      className={ctaClass}
      onClick={props.onClick}
      href={props.href}
      to={props.path}
      disabled={props.disabled}
    >
      {props.iconClass && (
        <i className={`cta__icon icon ${props.iconClass}`}></i>
      )}
      <span className="cta__content">{props.children}</span>
    </CustomTag>
  );
}

export default Cta;
